"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'company.tooltips.preview': 'Visualizza dettagli azienda',
};
